import { BaseApiClient } from "./BaseApiClient";
export const LEAGUES_ENDPOINTS = {
    BY_SPORT_ID: "/Leagues/GetBySportId",
    TOP_LEAGUES_BY_SPORT_ID: "/Leagues/GetTopLeaguesBySportId",
    LEAGUES_BY_LEAGUE_IDS: "/Leagues/GetByLeagueId"
};
/**
 * LeaguesApiClient - client for fetching Leagues BFF endpoints
 * @export
 * @class LeaguesApiClient
 * @extends {BaseApiClient}
 */
export class LeaguesApiClient extends BaseApiClient {
    /**
     * Fetch all leagues by sport id from BFF
     * @param {request} LeaguesBySportIdRequest
     * @throws {RequiredError}
     * @memberof LeaguesApiClient
     */
    getBySportId(request) {
        let fetchOptions = {
            request,
            fetchOptOverride: {}
        };
        return this.executeRequest(LEAGUES_ENDPOINTS.BY_SPORT_ID, fetchOptions);
    }
    /**
     * Fetch all top leagues by sport id from BFF
     * @param {request} TopLeaguesBySportIdRequest
     * @throws {RequiredError}
     * @memberof LeaguesApiClient
     */
    getTopLeaguesBySportId(request) {
        let fetchOptions = {
            request,
            fetchOptOverride: {}
        };
        return this.executeRequest(LEAGUES_ENDPOINTS.TOP_LEAGUES_BY_SPORT_ID, fetchOptions);
    }
    /**
    * Fetch all leagues by LeagueId
    * @param {request} LeaguesByLeagueIdRequest
    * @throws {RequiredError}
    * @memberof LeaguesApiClient
    */
    getLeaguesByLeagueId(request) {
        let fetchOptions = {
            request,
            fetchOptOverride: {}
        };
        return this.executeRequest(LEAGUES_ENDPOINTS.LEAGUES_BY_LEAGUE_IDS, fetchOptions);
    }
}
//# sourceMappingURL=LeaguesApiClient.js.map